module.exports = __webpack_public_path__ + "img/infographic2.a5f83c9c.png";